import messages from '../../locale/messages';
import { containsMalicious, inputDescLimit } from '../../helpers/textRestriction';

const validate = values => {

  const errors = {}

  if (!values.message) {
    errors.message = messages.required;
  } else if (values.message && values.message.toString().trim() == '') {
    errors.message = messages.required;
  } else if (values?.message?.length > inputDescLimit) {
    errors.message = messages.descriptionFieldRestriction;
  }else if (containsMalicious(values.message)) {
    errors.message = messages.invalidInput;;
  }

  return errors;
}

export default validate;